// extracted by mini-css-extract-plugin
export default {"card":"Bca-z","carousel":"Cca-z"};